export const SET_ROLES = "SET_ROLES";
export const SET_CREATED_ROLE = "SET_CREATED_ROLE";
export const SET_UPDATED_ROLE = "SET_UPDATED_ROLE";
export const REMOVE_DELETED_ROLE = "REMOVE_DELETED_ROLE";
export const SET_ROLE_ERROR = "SET_ROLE_ERROR";
export const SET_ROLES_LOADING = "SET_ROLES_LOADING";
export const SET_ROLES_FETCHING = "SET_ROLES_FETCHING";
